import script from "./GuidePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuidePage.vue?vue&type=script&setup=true&lang=ts"

import "./GuidePage.vue?vue&type=style&index=0&id=c558f0c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c558f0c8"]])

export default __exports__